import React from "react";
import "./Projects.css";
import ProjectCard from "./ProjectCard";

function Projects() {
  return (
    <div className="projects" id="work">
      <div className="projects__brand">
        <img src="./stars2.png" />
        <h2>Top picks</h2>
      </div>
      <p className="projects__tagline">
        Here are some of my top picks projects completed recently
      </p>
      <div className="projects__div">
        <div className="projects__first">
          <ProjectCard
            imgSrc={"./ProjectsSS/amazon.png"}
            title="Amazon UI"
            body={"Built using ReactJS(MERN Stack)"}
          />
          <ProjectCard
            imgSrc={"./ProjectsSS/covidtracker.png"}
            title="COVID Tracker"
            body={"Project made using ReactJS(data: API)"}
          />
          <ProjectCard
            imgSrc={"./ProjectsSS/tinder.png"}
            title="TINDER UI"
            body={"Powered with ReactJS(MERN Stack)"}
          />
        </div>
        <div className="projects__first projects__second">
          <ProjectCard
            imgSrc={"./ProjectsSS/spotify.png"}
            title="Spotify UI"
            body={"Project made using ReactJS(Spotify API)"}
          />
          <ProjectCard
            imgSrc={"./ProjectsSS/Blogsite.png"}
            title="Blogsite"
            body={"BUILT using Nodejs and EJS"}
          />
        </div>
      </div>
    </div>
  );
}

export default Projects;
